import { useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

import { LoadingFeedback } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import { routes } from 'Routes'
import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

import {
  Chip,
  Card,
  Box,
  Typography,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
  Button,
  makeStyles,
  Tab,
  Tabs,
} from '@material-ui/core'
import PropTypes from 'prop-types'

import styles from './styles'

const useStyles = makeStyles(styles)

const QuestionsReply = ({ questionnaire, refresh }) => {
  const classes = useStyles()
  const history = useHistory()
  const snackbar = useSnackbar()
  const { handleSubmit, control, setValue } = useForm()

  const [loading, setLoading] = useState(false)
  const [currentTab, setCurrentTab] = useState('all')

  const questionnaireId = questionnaire.id

  const activeQuestions = helpers.questionnaires.filterQuestions(
    questionnaire?.questions || [],
    {
      status: [
        constants.question.ANSWERED_STATUS,
        constants.question.PENDING_STATUS,
      ],
    },
  )
  const applicableChoiceQuestions = helpers.questionnaires.filterQuestions(
    activeQuestions || [],
    {
      applicableChoice: true,
    },
  )
  const answeredQuestions = helpers.questionnaires.filterQuestions(
    applicableChoiceQuestions || [],
    {
      status: constants.question.ANSWERED_STATUS,
    },
  )
  const pendingQuestions = helpers.questionnaires.filterQuestions(
    applicableChoiceQuestions || [],
    {
      status: constants.question.PENDING_STATUS,
    },
  )
  const inactiveQuestions = helpers.questionnaires.filterQuestions(
    questionnaire?.questions || [],
    {
      status: constants.question.INACTIVE_STATUS,
    },
  )
  const notApplicableChoiceQuestions = helpers.questionnaires.filterQuestions(
    activeQuestions || [],
    {
      applicableChoice: false,
    },
  )

  const questions = {
    active: activeQuestions,
    applicableChoice: applicableChoiceQuestions,
    answered: answeredQuestions,
    pending: pendingQuestions,
    inactive: inactiveQuestions,
    notApplicableChoice: notApplicableChoiceQuestions,
  }

  const [displayQuestions, setDisplayQuestions] = useState(questions.active)

  const submitAnswers = async (questionnaire) => {
    try {
      setLoading(true)
      await service.dponet.questionnaires.reply({
        questionnaireId,
        questionnaire,
      })
      setLoading(false)
      refresh()
      snackbar.open({
        message: 'Questionário respondido com sucesso',
        variant: 'success',
      })
    } catch (error) {
      setLoading(false)
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    }
  }

  const onSubmit = async (data) => {
    var questionnaireAnswers = { answers: [] }
    Object.keys(data).map((key) => {
      return questionnaireAnswers.answers.push({
        id: key,
        answer: data[key],
      })
    })

    await submitAnswers(questionnaireAnswers)
  }

  const handleChangeTabs = (_, value) => {
    setCurrentTab(value || constants.question.ALL_VALUE)

    switch (value) {
      case constants.question.PENDING_VALUE:
        return setDisplayQuestions(questions.pending)

      case constants.question.ANSWERED_VALUE:
        return setDisplayQuestions(questions.answered)

      case constants.question.INACTIVE_VALUE:
        return setDisplayQuestions(questions.inactive)

      default:
        return setDisplayQuestions(questions.active)
    }
  }

  const getBadgeValue = (tagValue) => {
    switch (tagValue) {
      case constants.question.PENDING_VALUE:
        return questions.pending.length
      case constants.question.ANSWERED_VALUE:
        return questions.answered.length
      case constants.question.INACTIVE_VALUE:
        return questions.inactive.length
      default:
        return questions.active.length
    }
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <Tabs
        scrollButtons="auto"
        onChange={handleChangeTabs}
        textColor="primary"
        indicatorColor="primary"
        value={currentTab}
        variant="standard"
      >
        {constants.question.TABS.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={
              <Box>
                {tab.label} ({getBadgeValue(tab.value)})
              </Box>
            }
          />
        ))}
      </Tabs>
      <Card>
        <Box pb={3}>
          {!!displayQuestions && displayQuestions.length !== 0 ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              {displayQuestions.map((question, index) => (
                <Box key={question.id}>
                  <Box mx={3} my={2} id={question.id}>
                    <Grid container>
                      <Grid item md={9} sm={12}>
                        <Grid container>
                          <Grid item xs={12}>
                            <Typography variant="h5">
                              {index + 1}. {question.theme}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Box width="100%" mt={1} ml={2}>
                              <Typography variant="body2">
                                {question.question}
                              </Typography>
                            </Box>
                          </Grid>
                          {question.status !==
                            constants.question.INACTIVE_STATUS && (
                            <Grid item sm={6} xs={12}>
                              <Box width="100%" mt={1} ml={2}>
                                <Controller
                                  control={control}
                                  name={question.id.toString()}
                                  defaultValue={question.answer}
                                  as={
                                    <RadioGroup row>
                                      <FormControlLabel
                                        value="Sim"
                                        control={<Radio color="primary" />}
                                        label="Sim"
                                      />
                                      <FormControlLabel
                                        value="Não"
                                        control={<Radio color="primary" />}
                                        label="Não"
                                      />
                                      <FormControlLabel
                                        value="Não se aplica"
                                        control={<Radio color="primary" />}
                                        label="Não se aplica"
                                      />
                                    </RadioGroup>
                                  }
                                  onChange={([event]) => {
                                    setValue(
                                      event.target.name,
                                      event.target.value,
                                    )
                                    return event
                                  }}
                                />
                              </Box>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item md={3} sm={12}>
                        <Box className={classes.boxQuestions}>
                          <Chip
                            size="small"
                            className={helpers.questions.statusColor(
                              question.status,
                              classes,
                            )}
                            label={helpers.questions.statusLabel(
                              question.status,
                            )}
                          />
                          {question.user && question.answer && (
                            <Box mt={2}>
                              <Typography variant="body2">
                                Respondido por: {question.user.name}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Grid>
                      {question.status === constants.question.INACTIVE_STATUS &&
                        question?.reason && (
                          <Grid xs={12}>
                            <Box
                              width="100%"
                              mt={1}
                              p={1}
                              className={classes.inactivateReasonBox}
                            >
                              <Box ml={1}>
                                <Typography variant="h6">
                                  Motivo da inativação
                                </Typography>
                              </Box>
                              <Box mt={1} ml={1}>
                                <Typography variant="body2">
                                  {question?.reason}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        )}
                    </Grid>
                  </Box>
                  <Divider />
                </Box>
              ))}
              <Box ml={2} mt={2} display="flex" justifyContent="flex-start">
                <Box pr={1}>
                  <Button
                    type="button"
                    variant="outlined"
                    onClick={() => history.push(routes.questionnaires.all)}
                  >
                    Voltar
                  </Button>
                </Box>
                <Box>
                  <Button color="primary" type="submit" variant="contained">
                    Salvar
                  </Button>
                </Box>
              </Box>
            </form>
          ) : (
            <Box mx={4} mt={3}>
              <Typography variant="body1">
                Não existe nenhuma questão com este status.
              </Typography>
            </Box>
          )}
        </Box>
      </Card>
    </>
  )
}

QuestionsReply.propTypes = {
  questionnaire: PropTypes.object,
  refresh: PropTypes.func,
}

QuestionsReply.defaultProps = {
  refresh: () => {},
}

export default QuestionsReply
